import { Component, ViewEncapsulation, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { KossayaService } from 'app/core/kossaya/kossaya.service';
import { filter } from 'rxjs/operators';
import { Subscription, Observable } from 'rxjs';
import { NotificationService, AppNotification } from 'app/core/services/notification.service';

@Component({
    selector: 'layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit, OnDestroy {
    currentUser: any = null;
    currentDate: string = '';
    currentTime: string = '';
    currentDay: string = '';
    activeRoute: string = '';
    sidebarOpen: boolean = false;
    sidebarCollapsed: boolean = false;
    profileMenuOpen: boolean = false;
    notificationMenuOpen: boolean = false;

    private timerInterval: any;
    private routerSub: Subscription;
    private pollingSub: Subscription;

    notifications$: Observable<AppNotification[]>;
    unreadCount$: Observable<number>;

    menuItems = [
        {
            label: 'Dashboard',
            icon: 'assets/images/kossaya/dashboard_ico.png',
            iconSelected: 'assets/images/kossaya/dashboard_ico_selected.png',
            route: '/dashboard',
            scope: 'both'
        },
        {
            label: 'Booking',
            useSvg: true,
            svgType: 'booking',
            route: '/booking',
            permission: 'order.read',
            scope: 'tenant'
        },
        {
            label: 'Manajemen Kamar',
            icon: 'assets/images/kossaya/bedroom_ico.png',
            iconSelected: 'assets/images/kossaya/bedroom_ico_selected.png',
            expanded: false,
            scope: 'tenant',
            children: [
                {
                    label: 'List Harga',
                    route: '/list-harga',
                    permission: 'room_type.read',
                    scope: 'tenant'
                },
                {
                    label: 'Fasilitas',
                    route: '/manajemen-fasilitas',
                    permission: 'facility-category.read',
                    scope: 'tenant'
                },
                {
                    label: 'Kamar',
                    route: '/manajemen-kamar',
                    permission: 'room.read',
                    scope: 'tenant'
                },
                {
                    label: 'Kontrak Sewa',
                    route: '/kontrak-sewa',
                    permission: 'rental-contract.read',
                    scope: 'tenant'
                },
                {
                    label: 'Pelanggaran',
                    route: '/manajemen-pelanggaran',
                    permissions: ['violation.read', 'setting.read'],
                    scope: 'tenant'
                },
                {
                    label: 'Voucher',
                    route: '/voucher',
                    permission: 'voucher.read',
                    scope: 'tenant'
                }
            ]
        },
        {
            label: 'Fasilitas Umum',
            useSvg: true,
            svgType: 'fasilitas-umum',
            route: '/fasilitas-umum',
            permission: 'facility-addon.read',
            scope: 'tenant'
        },
        {
            label: 'Data Penghuni',
            icon: 'assets/images/kossaya/penghuni_ico.svg',
            iconSelected: 'assets/images/kossaya/penghuni_ico_selected.svg',
            route: '/manajemen-tenant',
            permission: 'occupant.read',
            scope: 'tenant'
        },
        {
            label: 'Laporan',
            icon: 'assets/images/kossaya/laporan_ico.png',
            iconSelected: 'assets/images/kossaya/laporan_ico_selected.png',
            expanded: false,
            scope: 'tenant',
            children: [
                {
                    label: 'Pembelian Aset',
                    route: '/asset-purchases',
                    permission: 'asset-purchase.read',
                    scope: 'tenant'
                },
                {
                    label: 'Uang Masuk',
                    route: '/laporan',
                    permission: 'room_report.read',
                    scope: 'tenant'
                },
                {
                    label: 'Pembagian Hasil',
                    route: '/owner-disbursements',
                    permission: 'owner-disbursement.read',
                    scope: 'tenant'
                }
            ]
        },
        {
            label: 'Layanan Pendukung',
            useSvg: true,
            svgType: 'layanan-pendukung',
            expanded: false,
            scope: 'both',
            children: [
                {
                    label: 'Pengaduan',
                    route: '/manajemen-pengaduan',
                    permission: 'complaint.read',
                    scope: 'tenant'
                },
                {
                    label: 'Tugas Hari Ini',
                    route: '/tugas-harian',
                    permission: 'task_keeper.read',
                    scope: 'tenant'
                },
                {
                    label: 'Tugas & Penjaga',
                    route: '/manajemen-task',
                    permission: 'task_admin.read',
                    scope: 'tenant'
                },
                {
                    label: 'Log Activity',
                    route: '/log-activity',
                    permission: 'audit.read',
                    scope: 'both'
                },
                {
                    label: 'Setting Pembagian Hasil',
                    route: '/settings',
                    permission: 'setting.read',
                    scope: 'tenant'
                },
                {
                    label: 'Setting Pembayaran',
                    route: '/payment-settings',
                    permission: 'setting.read',
                    scope: 'tenant'
                }
            ]
        },
        {
            label: 'Manajemen Akses',
            useSvg: true,
            svgType: 'settings',
            expanded: false,
            scope: 'both',
            children: [
                {
                    label: 'User & Admin',
                    route: '/manajemen-user',
                    permission: 'user.read',
                    scope: 'both'
                },
                {
                    label: 'Role & Hak Akses',
                    route: '/manajemen-role',
                    permission: 'role.read',
                    scope: 'both'
                },
                {
                    label: 'Master Permission',
                    route: '/manajemen-permission',
                    permission: 'permission.read',
                    scope: 'both'
                }
            ]
        },
        {
            label: 'Master Platform',
            useSvg: true,
            svgType: 'master-platform',
            expanded: false,
            scope: 'central',
            children: [
                {
                    label: 'Tenant & Domain',
                    route: '/daftar-tenant',
                    permissions: ['tenant.read', 'permission.read'],
                    scope: 'central'
                },
                {
                    label: 'Master Permission',
                    route: '/manajemen-permission',
                    permission: 'permission.read',
                    scope: 'central'
                }
            ]
        }
    ];

    /** Determine whether the app is currently running in Tenant context */
    get isTenantContext(): boolean {
        if (typeof window !== 'undefined' && window.location && window.location.hostname) {
            const host = window.location.hostname.toLowerCase();
            // 1. Central hostnames
            if (
                host === 'admin.localhost' ||
                host === 'central.localhost' ||
                host === 'admin.kossaya.id' ||
                host === 'central.kossaya.id' ||
                host === 'kossaya.id' ||
                host === 'www.kossaya.id' ||
                host === 'localhost' ||
                host === '127.0.0.1'
            ) {
                return false;
            }
            // 2. Tenant hostnames
            if (
                host.endsWith('.kossaya.id') ||
                host.endsWith('.kossaya.com') ||
                host.endsWith('.localhost')
            ) {
                return true;
            }
        }

        const user = this.currentUser || this.authService.getCurrentUser();
        if (user && typeof user.is_tenant === 'boolean') {
            return user.is_tenant;
        }

        return false;
    }

    /** Filtered menu based purely on current user permissions and context scope */
    get visibleMenuItems() {
        const isTenant = this.isTenantContext;
        const user = this.currentUser || this.authService.getCurrentUser();
        const userPermissions: string[] = (user?.permissions || []).map((p: any) =>
            typeof p === 'string' ? p.toLowerCase() : (p?.name || '').toLowerCase()
        );

        const isItemAllowed = (item: any): boolean => {
            // Check scope (central vs tenant)
            if (item.scope === 'central' && isTenant) {
                return false;
            }
            if (item.scope === 'tenant' && !isTenant) {
                return false;
            }

            // Check if item has explicit permission requirements
            const itemPerms: string[] = (item.permissions || (item.permission ? [item.permission] : [])).map(
                (p: string) => p.toLowerCase()
            );

            if (itemPerms.length > 0) {
                return itemPerms.some((p: string) => userPermissions.includes(p));
            }

            // If item has no permission specified (e.g. Dashboard), it is visible
            return true;
        };

        return this.menuItems.filter(item => {
            if (item.scope === 'central' && isTenant) {
                return false;
            }
            if (item.scope === 'tenant' && !isTenant) {
                return false;
            }

            if (item.children) {
                return item.children.some((child: any) => isItemAllowed(child));
            }
            return isItemAllowed(item);
        });
    }

    /** Helper to get visible children of an accordion item */
    getVisibleChildren(item: any): any[] {
        if (!item?.children) return [];
        const isTenant = this.isTenantContext;
        const user = this.currentUser || this.authService.getCurrentUser();
        const userPermissions: string[] = (user?.permissions || []).map((p: any) =>
            typeof p === 'string' ? p.toLowerCase() : (p?.name || '').toLowerCase()
        );

        return item.children.filter((child: any) => {
            if (child.scope === 'central' && isTenant) {
                return false;
            }
            if (child.scope === 'tenant' && !isTenant) {
                return false;
            }

            const itemPerms: string[] = (child.permissions || (child.permission ? [child.permission] : [])).map(
                (p: string) => p.toLowerCase()
            );

            if (itemPerms.length > 0) {
                return itemPerms.some((p: string) => userPermissions.includes(p));
            }

            return true;
        });
    }

    constructor(
        private authService: AuthService,
        private router: Router,
        public kossayaService: KossayaService,
        private notificationService: NotificationService
    ) {
        this.notifications$ = this.notificationService.notifications$;
        this.unreadCount$ = this.notificationService.unreadCount$;
    }

    ngOnInit(): void {
        this.currentUser = this.authService.getCurrentUser();
        this.updateDateTime();
        this.timerInterval = setInterval(() => this.updateDateTime(), 1000);

        // Load area & property data (skip selection, auto-pick first)
        this.kossayaService.initialize();

        // Start notification polling
        this.pollingSub = this.notificationService.startPolling().subscribe();

        // Restore collapsed state from localStorage
        const saved = localStorage.getItem('sidebar_collapsed');
        if (saved === 'true') {
            this.sidebarCollapsed = true;
        }

        const initialPath = (this.router.url && this.router.url !== '/')
            ? this.router.url
            : (typeof window !== 'undefined' ? window.location.pathname : '');
        this.activeRoute = initialPath;
        this.autoExpandActiveMenu();

        this.routerSub = this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe((e: NavigationEnd) => {
                this.activeRoute = e.urlAfterRedirects || e.url;
                this.sidebarOpen = false;
                this.autoExpandActiveMenu();
            });
    }

    private autoExpandActiveMenu(): void {
        const path = this.activeRoute || (typeof window !== 'undefined' ? window.location.pathname : '');
        this.menuItems.forEach(item => {
            if (item.children && item.children.some((child: any) => path && child.route && (path === child.route || path.startsWith(child.route) || path.includes(child.route)))) {
                item.expanded = true;
            }
        });
    }

    ngOnDestroy(): void {
        if (this.timerInterval) clearInterval(this.timerInterval);
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.pollingSub) this.pollingSub.unsubscribe();
    }

    updateDateTime(): void {
        const now = new Date();
        const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
        const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
            'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

        this.currentDay = days[now.getDay()];
        this.currentDate = `${now.getDate().toString().padStart(2, '0')} ${months[now.getMonth()]} ${now.getFullYear()}`;
        this.currentTime = now.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) + ' WIB';
    }

    isActive(item: any): boolean {
        if (item.route) {
            return this.activeRoute.startsWith(item.route);
        }
        if (item.children) {
            return item.children.some((child: any) => this.isActive(child));
        }
        return false;
    }

    navigateTo(item: any): void {
        if (typeof item === 'string') {
            this.router.navigate([item]);
        } else if (item.children) {
            item.expanded = !item.expanded;
        } else if (item.route) {
            this.router.navigate([item.route]);
        }
    }

    /** Mobile: open/close sidebar drawer */
    toggleSidebar(): void {
        this.sidebarOpen = !this.sidebarOpen;
    }

    /** Desktop: expand/collapse sidebar (icon-only mode) */
    toggleCollapse(): void {
        this.sidebarCollapsed = !this.sidebarCollapsed;
        if (!this.sidebarCollapsed) {
            this.menuItems.forEach(item => item.expanded = false);
        }
        localStorage.setItem('sidebar_collapsed', String(this.sidebarCollapsed));
    }

    /** Toggle profile dropdown */
    toggleProfileMenu(): void {
        this.profileMenuOpen = !this.profileMenuOpen;
        if (this.profileMenuOpen) this.notificationMenuOpen = false;
    }

    /** Toggle notification dropdown */
    toggleNotificationMenu(): void {
        this.notificationMenuOpen = !this.notificationMenuOpen;
        if (this.notificationMenuOpen) this.profileMenuOpen = false;
    }

    closeNotificationMenu(): void {
        this.notificationMenuOpen = false;
    }

    onNotificationClick(notif: AppNotification): void {
        if (!notif.read_at) {
            this.notificationService.markAsRead(notif.id).subscribe();
        }

        if (notif.action_url) {
            this.router.navigateByUrl(notif.action_url);
        }
        this.closeNotificationMenu();
    }

    markAllNotificationsRead(): void {
        this.notificationService.markAllAsRead().subscribe();
    }

    /** Close profile dropdown when clicking outside */
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event): void {
        const target = event.target as HTMLElement;
        if (!target.closest('.user-avatar-wrapper')) {
            this.profileMenuOpen = false;
        }
        if (!target.closest('.notification-wrapper')) {
            this.notificationMenuOpen = false;
        }
    }

    logout(): void {
        this.authService.signOut().subscribe(() => {
            this.router.navigate(['/sign-in'], { replaceUrl: true });
        });
    }
}
